import React from "react";

function DashboardAdmin() {
  return (
    <div className="container mt-5">
      <h2>3Party Dashboard</h2>
      <p>Welcome,party3</p>
    </div>
  );
}

export default DashboardAdmin;